import * as Types from '../../../../packages/graphql/generated';

import { DocumentNode } from 'graphql';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';

export type ViewsFeedbackHeaderQueryVariables = {
  orgId: Types.Scalars['ID'];
};


export type ViewsFeedbackHeaderQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'idEnterprise'>
  )> }
);


export const ViewsFeedbackHeaderDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewsFeedbackHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"},"arguments":[],"directives":[]}]}}]}}]};

/**
 * __useViewsFeedbackHeaderQuery__
 *
 * To run a query within a React component, call `useViewsFeedbackHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewsFeedbackHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewsFeedbackHeaderQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useViewsFeedbackHeaderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewsFeedbackHeaderQuery, ViewsFeedbackHeaderQueryVariables>) {
        return ApolloReactHooks.useQuery<ViewsFeedbackHeaderQuery, ViewsFeedbackHeaderQueryVariables>(ViewsFeedbackHeaderDocument, baseOptions);
      }
export function useViewsFeedbackHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewsFeedbackHeaderQuery, ViewsFeedbackHeaderQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ViewsFeedbackHeaderQuery, ViewsFeedbackHeaderQueryVariables>(ViewsFeedbackHeaderDocument, baseOptions);
        }
export type ViewsFeedbackHeaderQueryHookResult = ReturnType<typeof useViewsFeedbackHeaderQuery>;
export type ViewsFeedbackHeaderLazyQueryHookResult = ReturnType<typeof useViewsFeedbackHeaderLazyQuery>;
export type ViewsFeedbackHeaderQueryResult = ApolloReactCommon.QueryResult<ViewsFeedbackHeaderQuery, ViewsFeedbackHeaderQueryVariables>;